import type { BookingResponse, EarlyDeparturePlanSummary } from '@/shared/api';
import { isOta } from './helpers';

export interface BookingActionFlags {
  message: boolean;
  reassign: boolean;
  upgrade: boolean;
  /** Nur manuelle Buchungen; storniert, nicht angereist oder abgereist lehnt der Server ab (409). */
  editOrCancel: boolean;
  historicalEdit: boolean;
  /** Ein begonnener Storno läuft noch – abschließen geht auch nach der Abreise. */
  finishCancel: boolean;
  /** Kanalbuchung: tatsächliche Abreise erfassen oder eine künftige planen. */
  earlyDeparture: boolean;
  plan: EarlyDeparturePlanSummary | null;
  /** Ändern und Aufheben gehen nur, solange der Plan nicht läuft. */
  planEditable: boolean;
  any: boolean;
}

const ACTIVE = ['Pending', 'Confirmed', 'CheckedIn'];

/** Welche Aktionen die Aktionsspalte anbietet – dieselben Bedingungen wie bisher, an einer Stelle. */
export function bookingActionFlags(
  booking: BookingResponse,
  manageable: boolean,
  apartmentCount: number,
): BookingActionFlags {
  const ota = isOta(booking);
  const messageChannel = booking.channel?.replace(/[^a-z0-9]/gi, '').toLowerCase();
  const running = ACTIVE.includes(booking.status) && booking.stayPhase !== 'Completed';
  const plan = booking.earlyDeparturePlan ?? null;
  const flags = {
    message: manageable && ota && (messageChannel === 'airbnb' || messageChannel === 'bookingcom'),
    reassign: manageable && apartmentCount > 1 && running,
    upgrade: manageable && running,
    editOrCancel:
      manageable &&
      !ota &&
      booking.status !== 'Cancelled' &&
      booking.status !== 'NoShow' &&
      booking.stayPhase !== 'Completed',
    historicalEdit:
      manageable &&
      !ota &&
      booking.isHistoricalDirectEntry === true &&
      booking.status !== 'Cancelled' &&
      booking.status !== 'NoShow',
    finishCancel: manageable && !ota && booking.capabilities?.hasUnfinishedCancellation === true,
    earlyDeparture:
      manageable &&
      ota &&
      (booking.capabilities?.canRecordOtaEarlyDeparture === true ||
        booking.capabilities?.canPlanOtaEarlyDeparture === true),
    plan: manageable && ota ? plan : null,
    planEditable: manageable && (plan?.status === 'Scheduled' || plan?.status === 'NeedsAttention'),
  };
  return {
    ...flags,
    any:
      flags.message ||
      flags.reassign ||
      flags.upgrade ||
      flags.editOrCancel ||
      flags.historicalEdit ||
      flags.finishCancel ||
      flags.earlyDeparture ||
      !!flags.plan,
  };
}
